import React, { PropsWithChildren, useEffect } from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { ITEToken } from "@timeedit/types/lib/types";
import { ERegion } from "@timeedit/types/lib/enums/region.enum";
import { TCustomerSignatureContext } from "@timeedit/types/lib/types/launchDarkly.type";

type TCoreLDInitializerProps = {
    customerSignature: string;
    region: string;
    token?: ITEToken;
};

export default function CoreLDInitializer(props: PropsWithChildren<TCoreLDInitializerProps>) {
    const ldClient = useLDClient();
    useEffect(() => {
        if (ldClient && props.customerSignature && props.token && props.region) {
            const isRootUser = props.token?.scopes.includes("TE_ROOT_USER") ?? false;

            const context: TCustomerSignatureContext = {
                kind: "customerSignature",
                key: props.customerSignature,
                region: props.region as ERegion,
                isRootUser,
                custom: { platformVersion: "3" },
            };
            ldClient.identify(context);
        }
    }, [props.customerSignature]);
    return <>{props.children}</>;
}
